import moment from 'moment/moment';

export const dateFormatDDMMYYYY = (date) => {

  if(date){
    var d = new Date(date),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    year = "" + d.getFullYear()
  
  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;
  
  return (
    [day, month, year].join("-")
  );
  }else{
    return null;
  }
  
};

export const dateFormatYYYYMMDD = (date) => {
  if(date){
    var d = new Date(date),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    year = "" + d.getFullYear()
  
  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;
  
  return (
    [year, month, day].join("-")
  );
  }else{
    return null;
  }

};


export const dateTime_MWORD = (date) => {
  let formattedIST = "";
  
  if(date) {
    const utcTime = moment.utc(date, 'DD-MM-YYYY HH:mm:ss');
    
    const istTime = utcTime.local();
    
    formattedIST = istTime.format('DD-MMM-YYYY');
  }

  return formattedIST;
};

export const dateTimeWordLanding = (date) => {
  let formattedIST = ""
  if(date){
    const utcTime = date;
    const istTime = moment.utc(utcTime).local();
    formattedIST  = istTime.format('Do-MMM-YYYY');  
  }
  return  formattedIST;
};

export const date_DDMMYYYY  = (date) => {
 
  let formattedDate = '';
  
  if (date) {
    formattedDate = moment(date).format('DD-MM-YYYY');
  }

  return formattedDate;
};


export const dateTime_DDMMYYhm = (date) => {
  let formattedIST = ""
  if(date){
    const utcTime = date;
    const istTime = moment.utc(utcTime).local();

    formattedIST = istTime.format('D MM YYYY h:mm');
  }

return formattedIST;
};


export const currentDate = () => moment().format('DD-MM-YYYY');
